import { useEffect, useState } from 'react';
import { Svg } from '@hopskipdrive/react-components';

import { bulkCancelRides, getTodaysRides } from '../../../api/services/Rides';
import { useTimezone } from '../../../hooks/useTimezone';
import { RemoveRiderFromTodaysRidesModal } from '../../../rides/components/RemoveRiderFromTodaysRidesModal';
import { useToastStore } from '../../../shared/stores/toastStore';
import { RideForRider } from '../../types';

import { Wrapper } from './styles';

export const RemoveRidersModal = ({ slugs, afterRemoveRiderFromRides }) => {
  const { formatInTimezone } = useTimezone();
  const { addToast } = useToastStore();
  const [showRides, setShowRides] = useState(false);
  const [rides, setRides] = useState<RideForRider[]>([]);

  useEffect(() => {
    const fetchRides = async () => {
      const { data } = await getTodaysRides({ slugs });

      setRides(data.trips);
    };

    showRides && rides.length === 0 && fetchRides();
  }, [slugs, showRides]);

  const cancelAllRides = async (cancellationReasonKey: string) => {
    const ids = rides.map((ride) => ride.id);

    const response = await bulkCancelRides({
      cancel: { ids, cancellation_reason_key: cancellationReasonKey },
    });

    if (response.type === 'success') {
      await afterRemoveRiderFromRides();
    } else {
      response.error.errors.forEach((error) => {
        addToast({
          message: error,
          severity: 'error',
        });
      });
    }
  };

  return (
    <Wrapper
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <Wrapper
        onClick={() => {
          setShowRides(true);
        }}
      >
        <Svg icon="cancel-next-ride" />
      </Wrapper>
      <RemoveRiderFromTodaysRidesModal
        isOpen={showRides && !!rides.length}
        formatInTimezone={formatInTimezone}
        rides={rides}
        onAccept={cancelAllRides}
        onCancel={() => setShowRides(false)}
      />
    </Wrapper>
  );
};
